import React from "react";
import styles from "./ServicesCard.module.scss";
import { SvgIconComponent } from "@mui/icons-material";

interface serviceCardProps {
  Icon: SvgIconComponent;
  title: string;
  description: string;
}

export const ServicesCard = ({
  Icon,
  title,
  description,
}: serviceCardProps) => {
  return (
    <div>
      <Icon className={styles.icon} fontSize="large" />
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
};
